import { useEffect, useState } from "react";
import ApiServices from "../services/apiservices";
import { Link } from "react-router-dom";
import { FiDownload } from "react-icons/fi";
import { FaFilePdf } from "react-icons/fa";

const FinancialStatementList = () => {
  const [statements, setStatements] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchStatements = async () => {
    setLoading(true);
    try {
      // Adjust API endpoint as needed
      const res = await ApiServices.getRequest(`/financial-statements/fetch.php`);
      setStatements(res.statements || res.posts || []);
    } catch (error) {
      console.error("Error fetching financial statements:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatements();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="w-full min-h-screen bg-white font-sans text-gray-800">
      {/* Top Banner / Hero Header */}
      {/* <div className="bg-[#14532d] py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-6">
          <h1 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-4">
            BEDC Audited <span className="text-yellow-400">Financial Statements</span>
          </h1>
          <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
          
          <nav className="flex items-center gap-2 text-xs md:text-sm text-gray-200 font-medium">
            <Link to="/" className="hover:text-yellow-400 transition-colors">
              Home
            </Link>
            <span className="text-gray-400">›</span>
            <span className="text-yellow-400 font-semibold">
              BEDC Audited Financial Statements
            </span>
          </nav>
        </div>
      </div> */}

      <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight  uppercase tracking-tight">
              BEDC Audited <span className="text-yellow-400">Financial Statements</span>
              </h1>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
            </div>
          
          </div>
        </div>
    </div>

      {/* Main Grid Content Area */}
      <div className="max-w-6xl mx-auto px-6 py-16 md:py-24">
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {[...Array(10)].map((_, idx) => (
              <div key={idx} className="animate-pulse flex flex-col space-y-3">
                <div className="w-12 h-14 bg-gray-200 rounded-lg"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                <div className="h-3 bg-gray-200 rounded w-1/2"></div>
              </div>
            ))}
          </div>
        ) : statements.length === 0 ? (
          /* Empty State */
          <div className="text-center text-gray-400 py-24 bg-gray-50 rounded-3xl border border-dashed border-gray-200">
            <FaFilePdf className="text-5xl text-red-400 mx-auto mb-4 opacity-50" />
            <p className="text-lg font-bold text-gray-600">
              No financial statements available at the moment.
            </p>
          </div>
        ) : (
          /* Document Grid Display */
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-8 gap-y-12">
            {statements.map((item) => (
              <div
                key={item.id}
                className="flex flex-col items-start space-y-3 group"
              >
                {/* Red PDF Icon with Custom Badge Styling */}
                <div className="relative inline-flex items-center justify-center">
                  <div className="w-12 h-14 bg-red-600 rounded-lg shadow-sm flex flex-col items-center justify-center text-white relative overflow-hidden group-hover:scale-105 transition-transform duration-300">
                    <FaFilePdf className="text-xl" />
                    <span className="text-[8px] font-black uppercase mt-1 tracking-wider bg-red-800 px-1 rounded">
                      PDF
                    </span>
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-sm font-semibold text-gray-900 leading-snug min-h-[2.5rem]">
                  {item.title}
                </h3>

                {/* Direct Download Button */}
                <a
                  href={item.fileUrl || item.downloadUrl || "#"}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sky-500 hover:text-sky-600 text-xs font-semibold transition-colors pt-1"
                >
                  <span>Download</span>
                  <FiDownload className="text-xs" />
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FinancialStatementList;